import { getValuesAsStringFromFilterGroup as i } from "./filter-functions.js";
const e = (t, o) => ({
  station: t.stationName,
  station_type: t.stationType,
  station_concept: t.stationConcept,
  station_service_filter: i(o, "services"),
  station_fuel_filter: i(o, "propellants"),
  station_ev_filter: i(o, "electricCharging")
});
export {
  e as getTrackingObjectForStation
};
